import {  IEnergyOverview } from "./types";
import { OverviewPanel } from '../../ReportsAndStatistics/Energy/Heatmap/OverviewPanel'


const InsightsPanel = (props: IEnergyOverview) => {
    return (<>
        <OverviewPanel {...props} ></OverviewPanel>
    </>)
}

export default InsightsPanel